import React, { useEffect, useRef, useState } from 'react'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { RootState } from '../../Redux/store'
import { TGetFilterVal } from './GenericFilters'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'
import BusinessParamDropdown from './BusinessParamDropdown'
import { updateDurationsFilterInputs } from '../VuParamsHelpers'

const replaceFilterValueParameter_HLDecimal = (
    replacedStr: any,
    listItemId: any,
    filterableId: any,
    filterValueListId: any,
    filterValue: string,
    GetFilterValues: (filterValArgs: TGetFilterVal) => void,
    selectedItem: string,
    selectedParameters: any,
    MetadataId: number
) => {
    // const getInputValuesRef = useRef<{ [key: string]: any }>({})
    const [HLDecimalValues, setDecimalValues] = React.useState({})
    const setInput = (key: string, value: any) => {
        let copyInputVal = {...HLDecimalValues}
        copyInputVal = {
            ...copyInputVal,
            [key]: value  == "" ? undefined : value,
        }
        setDecimalValues(copyInputVal)
        GetFilterValues({displayText: filterValue, selectedValues: copyInputVal, keyValue: filterValueListId})
    }
    
    const getNonInputText = () =>{
        GetFilterValues({displayText: filterValue, selectedValues: "", keyValue: filterValueListId})
    }

    useEffect(() => {
        if(selectedItem != null){
            GetFilterValues({displayText: filterValue, selectedValues: HLDecimalValues, keyValue: filterValueListId})
        }
    }, [selectedItem])

    useEffect(() => {
            if (selectedParameters.data !== null) {
                if (selectedParameters.data.filterValueListId == filterValueListId && selectedParameters.data.metaDataId == MetadataId) {
                    
                    updateDurationsFilterInputs(setDecimalValues, "HLDECIMAL", selectedParameters)
                }
            }
        }, [])
        
    const parseReplacedStr = (str: string) => {
        // Define regex patterns for the placeholders
        const regex = new RegExp(
            `\\[(${enumHLSearchDataType.HLDecimal}|${enumHLSearchDataType.HLDecimal_From}|${enumHLSearchDataType.HLDecimal_To})\\]`,
            'gi'
        )

        const parts = str.split(regex).filter(Boolean) // Split by placeholders and remove empty parts

        if (parts.length === 1) {
            return (
                <span
                    key="plain-text"
                    onClick={()=>getNonInputText()}
                >
                    {parts[0]}
                </span>
            );
        }
        
        const jsxParts = parts.map((part, index) => {
            if (part === enumHLSearchDataType.HLDecimal) {

                return (
                    <input
                        key={index}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLDecimal}`}
                        size={10}
                        maxLength={10}
                        defaultValue=""
                        autoComplete="off"
                        className="filtervalue-input-text input-decimal"
                        onChange={(e) => setInput(enumHLSearchDataType.HLDecimal, e.target.value)}
                    />
                )
            }

            if (part === enumHLSearchDataType.HLDecimal_From) {
                // FP-11206 Removed business parameter check because Business parameter is only available for HLDuration,HLNumber,HLCount, HLMoney
                return (
                    <input
                        key={index}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLDecimal_From}`}
                        size={10}
                        maxLength={10}
                        defaultValue=""
                        autoComplete="off"
                        className="filtervalue-input-text input-decimal"
                        onChange={(e) =>
                            setInput(enumHLSearchDataType.HLDecimal_From, e.target.value)
                        }
                    />
                )
            }

            if (part === enumHLSearchDataType.HLDecimal_To) {
                // FP-11206 Removed business parameter check because Business parameter is only available for HLDuration,HLNumber,HLCount, HLMoney
                return (
                    <input
                        key={index}
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLDecimal_To}`}
                        size={10}
                        maxLength={10}
                        defaultValue=""
                        autoComplete="off"
                        className="filtervalue-input-text input-decimal"
                        onChange={(e) =>
                            setInput(enumHLSearchDataType.HLDecimal_To, e.target.value)
                        }
                    />
                )
            }

            // If it's just regular text, return it as is
            return part
        })

        return jsxParts
    }

    // Return the JSX for the replaced string
    return <>{parseReplacedStr(replacedStr)}</>
}

export default replaceFilterValueParameter_HLDecimal
